module.exports = __webpack_public_path__ + "img/img30.de4f9f8c.png";